import APIObject from '../object'
import Enum from '../enums'
import { DateYMD } from '../dates'

export default class EmployeeHour extends APIObject {
  relations () {
    return {
      date: { type: DateYMD },
      type: { type: EmployeeHourType },
      rosterFrequency: { type: EmployeeHourRosterFrequency },
      rosterWeek: { type: EmployeeHourRosterWeek },
      leaveType: { type: EmployeeHourLeaveType },
    }
  }

  get isDefaultHours () {
    return this.type === EmployeeHourType.defaultHour
  }

  get isOverrideHours () {
    return this.type === EmployeeHourType.override
  }

  get isLeaveTypeNone () {
    return this.leaveType === EmployeeHourLeaveType.none
  }

  get isLeaveTypeSick () {
    return this.leaveType === EmployeeHourLeaveType.sick
  }

  get isLeaveTypeHoliday () {
    return this.leaveType === EmployeeHourLeaveType.holiday
  }

  get isLeaveTypeOther () {
    return this.leaveType === EmployeeHourLeaveType.other
  }

  get isOnLeave () {
    return !this.isLeaveTypeNone
  }

  get isRosterFrequencyWeekly () {
    return this.rosterFrequency === EmployeeHourRosterFrequency.weekly
  }

  get isRosterFrequencyFortnightly () {
    return this.rosterFrequency === EmployeeHourRosterFrequency.fortnightly
  }

  get isRosterFrequencyMonthly () {
    return this.rosterFrequency === EmployeeHourRosterFrequency.monthly
  }

  get status () {
    if (this.isOnLeave) {
      return EmployeeHourRosterStatus.leave
    }

    if (this.working) {
      return EmployeeHourRosterStatus.working
    }

    return EmployeeHourRosterStatus.notWorking
  }

  set status (value) {
    if (value === EmployeeHourRosterStatus.leave) {
      this.working = false
      this.leaveType = EmployeeHourLeaveType.holiday
    } else if (value === EmployeeHourRosterStatus.working) {
      this.working = true
      this.leaveType = EmployeeHourLeaveType.none
    } else {
      this.working = false
      this.leaveType = EmployeeHourLeaveType.none
    }
  }
}

export const EmployeeHourRosterStatus = new Enum({
  working: { value: 'working', description: 'roster.working' },
  notWorking: { value: 'notWorking', description: 'roster.notWorking' },
  leave: { value: 'leave', description: 'roster.leave' },
})

export const EmployeeHourRosterFrequency = new Enum({
  weekly: { value: 1, description: 'datetime.range.weekly' },
  fortnightly: { value: 2, description: 'datetime.range.fortnightly' },
  monthly: { value: 4, description: 'datetime.range.monthly' },
})

export const EmployeeHourRosterWeek = new Enum({
  a: { value: 1, description: 'api.models.employeeHour.a' },
  b: { value: 2, description: 'api.models.employeeHour.b' },
  c: { value: 3, description: 'api.models.employeeHour.c' },
  d: { value: 4, description: 'api.models.employeeHour.d' },
})

export const EmployeeHourType = new Enum({
  none: { value: 'none', description: 'general.none' },
  default: { value: 'default', description: 'general.default' },
  override: { value: 'override', description: 'general.override' },
})

export const EmployeeHourLeaveType = new Enum({
  none: { value: 0, description: 'general.none' },
  sick: { value: 1, description: 'roster.sick' },
  holiday: { value: 2, description: 'roster.holiday' },
  other: { value: 3, description: 'general.other' },
})
